/**
 * 网站标题管理工具类
 * 提供全局的网站标题管理功能
 */
import axios from "@/api/request";

class WebsiteTitleManager {
    constructor() {
        this.title = "食品交易平台"; // 默认标题
        this.loaded = false;
    }

    /**
     * 从后端加载网站标题
     */
    async loadTitle() {
        if (this.loaded) {
            return this.title;
        }

        try {
            const response = await axios.get("/api/favicon/website-title");
            if (response.code === 200 && response.data) {
                this.title = response.data;
                this.loaded = true;
                // 设置浏览器标题
                document.title = this.title;
            }
        } catch (error) {
            console.error("获取网站标题失败:", error);
            // 使用默认标题
            this.title = "食品交易平台";
            this.loaded = true;
            document.title = this.title;
        }

        return this.title;
    }

    /**
     * 设置网站标题
     */
    setTitle(newTitle) {
        this.title = newTitle;
        document.title = newTitle;
    }

    /**
     * 获取当前标题
     */
    getTitle() {
        return this.title;
    }

    /**
     * 重置加载状态（用于强制重新加载）
     */
    reset() {
        this.loaded = false;
    }
}

// 创建单例实例
const websiteTitleManager = new WebsiteTitleManager();

export default websiteTitleManager;